import React from 'react';

const SignIn = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-sky-100 px-4 py-12">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-blue-600 mb-4">Sign In</h1>
        <p className="text-gray-700 text-lg mb-6">
          We're working hard to bring user accounts and sign-in functionality very soon.
        </p>
        <p className="text-gray-600">
          Stay tuned! You'll soon be able to save your transcriptions, manage files, and more.
        </p>
        <div className="mt-6 text-sm text-gray-500">
          Need help? <a href="/contact" className="text-blue-600 hover:underline">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
